import { useEffect } from 'react'
import { runSaga } from 'store/sagaMiddleware'

export default function useSaga (saga, ...args) {
  useEffect(() => {
    const channelDataSaga = runSaga(saga, ...args)

    return () => {
      channelDataSaga.cancel()
    }
  }, [saga, ...args])
}
